<template>
  <div class="offer-display-info">
    <img class="offer-display-info-image" :src="showcaseImage" alt="" />
    <div class="offer-text">
      <div class="h-heading-h2">{{ branding | translateI18nObject('label') }}</div>
      <div class="category h-text-3">
        {{ offer | translateI18nObject('category_name') }}{{ _get(offer, `category_name.${currentLocale}`) && _get(branding, `region_label.${currentLocale}`) ? ' / ' : '' }}{{ branding | translateI18nObject('region_label') }}
      </div>
      <div class="description h-text-2">{{ branding | translateI18nObject('description') }}</div>
      <div v-if="!_isEmpty(supportBranding)" class="publisher-display">
        <img class="publisher-display-image" :src="showcaseImageSupport" />
        <div>{{ supportBranding | translateI18nObject('label') }}</div>
      </div>

      <merchants-modal v-if="offer_id" class="link" :offer_id="offer_id" :publisher_id="publisher_id" />
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { spaceShowcaseImageHelper } from '@/composables/image-helper';
import MerchantsModal from '@/components/modals/MerchantsModal';
import { mapGetters } from 'vuex';

export default {
  props: {
    offer_id: {
      type: String,
    },
    publisher_id: {
      type: String,
    },
    branding: {
      type: Object,
      default: () => ({}),
    },
    offer: {
      type: Object,
      default: () => ({}),
    },
    supportBranding: {
      type: Object,
      default: () => ({}),
    },
  },
  name: 'offer-display-info',
  components: {
    MerchantsModal,
  },
  setup() {
    return {
      spaceShowcaseImageHelper,
    };
  },
  computed: {
    ...mapGetters('ui', ['currentLocale']),
    showcaseImage() {
      return spaceShowcaseImageHelper(_get(this.$options.filters.translateI18nObject(this.branding, 'images.showcases'), '0'));
    },
    showcaseImageSupport() {
      return spaceShowcaseImageHelper(_get(this.$options.filters.translateI18nObject(this.supportBranding, 'images.showcases'), '0'));
    },
  },
  methods: {
    _get,
    _isEmpty,
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/utilities/mixin.scss';

.offer-display-info {
  position: relative;
  @media ($sm-min) {
    display: flex;
  }
}

.offer-display-info-image {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  margin-bottom: var(--gap);

  @media ($sm-min) {
    max-height: 170px;
    max-width: 280px;
    margin-right: var(--gap);
    margin-bottom: 0;
    height: fit-content;
    aspect-ratio: 2;
  }

  @media ($md-min) {
    max-width: 340px !important;
  }
}

.category {
  color: #4f4f4f;
}

.description {
  margin-top: var(--gap-small);
  // color: var(--color-text-secondary);

  @include cut-after-x-line(4);
}

.publisher-display {
  display: flex;
  align-items: center;
  margin-top: var(--gap);
  margin-bottom: var(--gap);
}

.publisher-display-image {
  margin-right: var(--gap-small);
  max-width: 104px;
  max-height: 56px;
}
</style>
